import StarterKit from "@tiptap/starter-kit";

export function getStarterKitExtensions(options: any) {
  return StarterKit.configure(options);
}
